module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsMother.b7943f4.webp";